import React, { useMemo } from 'react';
import clsx from 'clsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useTableStyles } from '../../../common/styles/TableStyles';
import { formatNumber } from '../../../common/data_display/utils';

function CustomCell(props) {
  return (
    <TableCell className={props.classes} align="center" colSpan={props.colSpan} rowSpan={props.rowSpan}>
      {props.children}
    </TableCell>
  );
}

export default function AdmDefectTable(props) {
  const classes = useTableStyles();
  const { raw_response } = props;
  const { predicted_defects_at_d0, predicted_defects_at_d2, predicted_closure_at_d0, predicted_closure_at_d2, predicted_open_at_d0, predicted_open_at_d2 } = raw_response;

  const rows = useMemo(() => {
    const d0Defects = predicted_defects_at_d0 ?? 'N/A';
    const d0Closure = predicted_closure_at_d0 ?? 'N/A';
    const d0Open = predicted_open_at_d0 ?? 'N/A';
    const d2Defects = predicted_defects_at_d2 ?? 'N/A';
    const d2Closure = predicted_closure_at_d2 ?? 'N/A';
    const d2Open = predicted_open_at_d2 ?? 'N/A';

    return [
      {
        defectType: 'Predicted Defects',
        atD0: d0Defects,
        atD2: d2Defects,
      },
      {
        defectType: 'Predicted Closure',
        atD0: d0Closure,
        atD2: d2Closure,
      },
      {
        defectType: 'Predicted Open',
        atD0: d0Open,
        atD2: d2Open,
      },
    ];
  }, [predicted_defects_at_d0, predicted_closure_at_d0, predicted_open_at_d0, predicted_defects_at_d2, predicted_closure_at_d2, predicted_open_at_d2]);

  const headerClasses = clsx(classes.headCell, classes.head);
  const nameClasses = clsx(classes.borderedCell, classes.cell, classes.rowName);
  const valueClasses = clsx(classes.borderedCell, classes.valueCell, classes.rowValue);

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography className={classes.title} gutterBottom variant="h3">
            ADM Defect Predictions
          </Typography>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomCell classes={headerClasses}>
                </CustomCell>
                <CustomCell classes={headerClasses}>
                  At D0
                </CustomCell>
                <CustomCell classes={headerClasses}>
                  At D2
                </CustomCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <CustomCell classes={nameClasses}>
                      {row.defectType}
                    </CustomCell>
                    <CustomCell classes={valueClasses}>
                      {typeof row.atD0 === 'number' ? formatNumber(Math.round(row.atD0 * 10) / 10) : row.atD0}
                    </CustomCell>
                    <CustomCell classes={valueClasses}>
                      {typeof row.atD2 === 'number' ? formatNumber(Math.round(row.atD2 * 10) / 10) : row.atD2}
                    </CustomCell>
                  </TableRow>
              )})}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </React.Fragment>
  );
}
